export type ValidationType = 'error' | 'success';

type ValidationIconEntry = {
  color: string;
  inlineIcon: string;
  messageIcon: string;
};

// `color` consumed by the v1 Icon atom (CSS class enum, not a CSS var).
// TODO: replace with --ui-color-notification-*-icon tokens when Icon v2 lands.
export const VALIDATION_CONFIG: Record<ValidationType, ValidationIconEntry> = {
  error: {
    color: 'red',
    inlineIcon: 'caution-outline',
    messageIcon: 'caution-fill-sm',
  },
  success: {
    color: 'success',
    inlineIcon: 'check-circle-outline',
    messageIcon: 'check-circle-fill-sm',
  },
};
